<div class="row">
    <div class="col-lg-12" id="pageSelection">
        <div class="card selectColumns isMinimizable minimize"
             [stepContent]="pdfPageStepContent"
             joyrideStep="pdfPageStep">
            <div class="card-header">
                <div class="card-title">
                    <i class="fa fa-angle-up"></i>
                    Personnalisation du PDF
                </div>
            </div>
            <div class="card-body">
                <mat-button-toggle-group class="container-fluid" [multiple]="true" #group="matButtonToggleGroup"
                                         [value]="user.user_dashboard.pdf_page"
                                         (change)="onPageChange(group.value)">
                    <div class="col-md-12 page-list">
                        <h5>Sélection des pages</h5>

                        <mat-button-toggle value="annonce">
                            Annonce
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="secteur">
                            Analyse du secteur
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="secteur_bis" class="last">
                            Analyse du secteur - page 2
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="finance">
                            Analyse financière
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="patrimoniale">
                            Analyse patrimoniale
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                    </div>
                </mat-button-toggle-group>
                <div class="col-md-12">
                    <h5>Qualité du rapport</h5>
                    <mat-button-toggle-group class="container-fluid" [ngModel]="user.user_dashboard.pdf_quality"
                                             (change)="user.user_dashboard.pdf_quality = $event.value;updateDashboard()">
                        <mat-button-toggle value="normal">
                            Standard / Rapide
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                        <mat-button-toggle value="hd" class="last">
                            Haute définition
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="book">
    <div id="book">

        <button [hidden]="loading" [disabled]="!ready" (click)="createPdf()"
                class="dl_button btn btn-primary btn-lg text-white"
                [stepContent]="pdfDownloadStepContent"
                [stepContentParams]="{'user': authenticationService.currentUser}"
                joyrideStep="pdfDownloadStep">
            <mat-spinner diameter="25" color="second" [hidden]="ready"></mat-spinner>
            <i class="fa cfa cfa-pdf text-white"></i> Télécharger le rapport
        </button>
        <mat-spinner diameter="25" color="second" [hidden]="!loading"></mat-spinner>

        <div id="annonce" class="page"
             [stepContent]="pdfAnnonceStepContent"
             [stepContentParams]="{'user': authenticationService.currentUser}"
             (next)="openPageSelection()"
             joyrideStep="pdfAnnonceStep">
            <div class="subpage">
                <div class="fontChange">
                    <i class="fa fa-plus" (click)="upFont()" matTooltip="Augmente la taille de la description"></i>
                    <i class="fa fa-minus" (click)="downFont()" matTooltip="Diminue la taille de la description"></i>
                </div>
                <div [ngClass]="{'subpageWrap': !pdfConfig.display_contact}">
                    <div class="logo_wrap">
                        <img class="logo" src="{{ pdfConfig.logo_url }}"/>
                    </div>
                    <div class="title">
                        <input type="text" class="input_title"
                               [(ngModel)]="title">
                    </div>
                    <div class="kpi-3">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/coins_white.png"/>
                            <label>Investissement clé en main</label>
                            <p class="value">{{ favorite.total_price | number: '1.0-0' }} €</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <img class="icon" src="assets/measure_white.png"/>
                            <label>Superficie</label>
                            <p class="value">{{ favorite.square }} m²</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/009-get-money_white.png"/>
                            <label>Rendement brut</label>
                            <p class="value">{{ favorite.efficiency_brut | number: '1.1-1' }} %</p>
                        </div>
                    </div>
                    <div class="desc">
                        <b>Descriptif du projet</b>
                        <p class="wrap_textarea">
                            <textarea id="descFields" matInput [(ngModel)]="favorite.description"
                                      (ngModelChange)="edit($event, 'description')"></textarea>
                        </p>
                    </div>
                    <div class="notes" *ngIf="pdfConfig.display_note">
                        <b>Vos notes</b>
                        <p class="wrap_textarea">
                            <textarea matInput [(ngModel)]="favorite.comment"
                                      (ngModelChange)="edit($event, 'comment')"></textarea>
                        </p>
                    </div>
                    <div class="pictures">
                        <div class="wrap"
                             [ngClass]="{'small': favorite.pictures.length <= 3, 'big': favorite.pictures.length > 3}">
                            <img id="my-image" class="picture"
                                 *ngFor="let picture of favorite.pictures.slice(0,5); index as i;"
                                 [hidden]="picture == '/assets/no-photo.png'"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">
                        </div>
                    </div>
                    <div class="contact row" *ngIf="pdfConfig.display_contact">
                        <ng-container *ngIf="pdfConfig.contact_tpl == 'agence'">
                            <div class="col-md-6">
                                <b>Votre contact chasseur</b><br/>
                                {{ user.firstname }} {{ user.lastname }}<br/>
                                {{ user.email }}<br/>
                                <br/>
                                <span *ngIf="pro_data.mobile != ''">Mobile : {{ pro_data.mobile }}</span>
                            </div>
                            <div class="col-md-6" [innerHTML]="pdfConfig.contact">
                            </div>
                        </ng-container>
                        <ng-container *ngIf="pdfConfig.contact_tpl == 'solo'">
                            <div class="col-md-2 offset-3">
                                <img class="contact_visuel" src="{{pdfConfig.contact_visuel}}"
                                     *ngIf="pdfConfig.contact_visuel != ''">
                            </div>
                            <div class="col-md-7 ps-4" [innerHTML]="pdfConfig.contact">
                            </div>
                        </ng-container>
                    </div>
                </div>
                <p class="bottom_link" *ngIf="!pdfConfig.display_contact">
                    <span>Analyses et dossier effectués avec <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
            </div>
        </div>

        <div id="secteur" class="page">
            <div class="subpage">
                <div
                    [ngClass]="{'subpageWrap': true, 'withImg': pdfConfig.visuel_1 != '', 'withLegalNotice': pdfConfig.display_legal_notice == true}">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse du secteur
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="kpi-3">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/032-human-resources_white.png"/>
                            <label>Nombre d'habitants</label>
                            <p class="value">{{ favorite.ad_city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] | number: '1.0-0'}}</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <img class="icon" src="assets/dashboard_white.png"/>
                            <label>Tension locative</label>
                            <p class="value"
                               *ngIf="favorite.ad_city.loc_service_tensiometre.all.loc != '-1'">{{ favorite.ad_city.loc_service_tensiometre.all.loc }}
                                / 8</p>
                            <p class="value" *ngIf=" favorite.ad_city.loc_service_tensiometre.all.loc == '-1'">-</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/measure_white.png"/>
                            <label>Prix au m² moyen</label>
                            <p class="value">{{ advice_price | number: '1.0-0' }} €/m²</p>
                        </div>
                    </div>
                    <div class="card block block_info">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-color">Informations sur la ville</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row">
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Niveau de vie moyen par habitant
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-color">{{ favorite.ad_city.carac_commune.MED_NV | number: '1.0-0' }}
                                        <span
                                            class="unit">€</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Taux de logements vacants
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-color">{{ favorite.ad_city.logement.T_LV * 100 | number: '1.1-1' }}
                                        <span class="unit">%</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Taux d'étudiants
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-color">{{ favorite.ad_city.carac_commune.T_etud * 100 | number: '1.1-1' }}
                                        <span class="unit">%</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Taux de chômage
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-color">{{ favorite.ad_city.carac_commune.T_chom * 100 | number: '1.1-1' }}
                                        <span class="unit">%</span></b>
                                </div>

                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Taux de taxe foncière
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-color">{{ favorite.ad_city.logement.TF * 100 | number: '1.1-1' }}
                                        <span class="unit">%</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Ancienneté des locataires
                                        <br/>
                                        <br/>
                                    </label>
                                    <b class="value text-color">{{ favorite.ad_city.logement.anc_loc_ann | number: '1.1-1' }}
                                        <span class="unit">ans</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Part des ménages ayant au moins 1 voiture
                                    </label>
                                    <b class="value text-color">{{ favorite.ad_city.logement['T_Men_1+voit'] * 100 | number: '1.1-1' }}
                                        <span class="unit">%</span></b>
                                </div>
                                <div class="col-xl-3 col-6 text-center indicateur">
                                    <label>
                                        Part des ménages ayant une place de parking
                                    </label>
                                    <b class="value text-color">{{ favorite.ad_city.logement.T_Men_park * 100 | number: '1.1-1' }}
                                        <span class="unit">%</span></b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block_2graph">
                        <div class="card block block_rent">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Loyer moyen</h3>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <div class="card-text row">
                                    <div echarts [options]="rentOptions" [merge]="rentData"
                                         class="rentChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                         (chartInit)="onRentChartInit($event)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="card block block_price" *ngIf="pdfConfig.visuel_1 == ''">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Prix moyen</h3>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <div class="card-text row">
                                    <div echarts [options]="priceOptions" [merge]="priceData"
                                         class="priceChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                         (chartInit)="onPriceChartInit($event)"></div>
                                </div>
                            </div>
                        </div>

                        <div class="card block block_price" *ngIf="pdfConfig.visuel_1 != ''">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Évolution des prix de
                                        l'immobilier</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row" *ngIf="priceData.series.length > 0">
                                    <div echarts [options]="priceEvolOptions" [merge]="priceEvolData"
                                         class="priceEvolChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                         (chartInit)="onPriceChartInit($event)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>

                    <div class="card block block_price_evol" *ngIf="pdfConfig.visuel_1 == ''">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-color">Évolution des prix de l'immobilier</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row" *ngIf="priceEvolData.series.length > 0">
                                <div echarts [options]="priceEvolOptions" [merge]="priceEvolData"
                                     class="priceEvolChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                     (chartInit)="onPriceChartInit($event)"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                        Document non contractuel, rédigé à titre indicatif, qui ne saurait
                        engager la responsabilité de {{ pdfConfig.societe}}. L'ensemble des
                        informations diffusées dans ce document sont des estimations
                        susceptibles de varier en fonction des conditions de marché.
                    </span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>

        <div id="secteur_bis" class="page">
            <div class="subpage">
                <div
                    [ngClass]="{'subpageWrap': true, 'withImg': pdfConfig.visuel_1b != '', 'withLegalNotice': pdfConfig.display_legal_notice == true}">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse du secteur
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="kpi-3">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/032-human-resources_white.png"/>
                            <label>Écoles et universités</label>
                            <p class="value">{{ favorite.ad_city.ecole.tot_ecole | number: '1.0-0'}}</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <img class="icon" src="assets/shop_white.svg"/>
                            <label>Commerces</label>
                            <p class="value">{{ favorite.ad_city.commerce.tot_com | number: '1.0-0'}}</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/teamwork_white.svg"/>
                            <label>Entreprises</label>
                            <p class="value">{{ favorite.ad_city.ets.ETNTOT20 | number: '1.0-0' }}</p>
                        </div>
                    </div>
                    <div class="block_2graph">
                        <div class="card block block_map">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Localisation du bien</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <img class="img-fluid rounded-1 mb-3"
                                     src="{{apiUrl}}img/{{ favorite.id }}/city/default"/>
                            </div>
                        </div>
                        <div class="blocks_map_side">
                            <div class="card block block_map_side mb-5">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="{{ pdfConfig.h3_class}} text-color">Écoles et universités</h3>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div echarts [options]="schoolOptions" [merge]="schoolData"
                                             class="villeChart"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="card block block_map_side">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="{{ pdfConfig.h3_class}} text-color">Répartition des commerces</h3>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div echarts [options]="shopOptions" [merge]="shopData"
                                             class="villeChart"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>

                    <div class="card block">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}} text-color">Évolution de la population</h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div echarts [options]="popOptions" [merge]="popData"
                                 [ngClass]="{'popChartBig': pdfConfig.visuel_1b == '', 'popChart': true}"
                                 (chartInit)="onChartPopInit($event)"></div>
                        </div>
                    </div>

                </div>

                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                        Document non contractuel, rédigé à titre indicatif, qui ne saurait
                        engager la responsabilité de {{ pdfConfig.societe}}. L'ensemble des
                        informations diffusées dans ce document sont des estimations
                        susceptibles de varier en fonction des conditions de marché.
                    </span>
                </p>
                <img *ngIf="pdfConfig.visuel_1b != ''" class="bottom_img" src="{{ pdfConfig.visuel_1b }}"/>
            </div>
        </div>

        <div id="finance" class="page">
            <div class="subpage">
                <div
                    [ngClass]="{'subpageWrap': true, 'withImg': pdfConfig.visuel_2 != '', 'withLegalNotice': pdfConfig.display_legal_notice == true}">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse financière du projet
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="kpi-3">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/050-wallet_white.png"/>
                            <label>Loyer mensuel HC</label>
                            <p class="value">{{ favorite.amount_rent | number: '1.0-0'}} €</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <img class="icon" src="assets/009-get-money_white.png"/>
                            <label>Rendement brut</label>
                            <p class="value">{{ favorite.efficiency_brut | number: '1.1-1' }} %</p>
                        </div>

                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/030-cash.png"/>
                            <label>Taxe foncière</label>
                            <p class="value">{{ favorite.amount_property_tax | number: '1.0-0'}} €</p>
                        </div>
                    </div>

                    <div class="block_2graph">
                        <div class="card block block_charges">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Répartition des charges
                                        mensuelles</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row">
                                    <div echarts [options]="chargeOptions" [merge]="chargeData" class="chargeChart"
                                         (chartInit)="onChargeChartInit($event)"></div>
                                </div>
                            </div>
                        </div>

                        <div class="card block block_recap">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Charges annuelles</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row">
                                    <table>
                                        <tr>
                                            <th>Taxe foncière</th>
                                            <td>
                                                {{favorite.amount_property_tax}} €/an
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Assurance PNO</th>
                                            <td>
                                                {{favorite.building_insurance}} €/an
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Gestion agence ({{favorite.agence}} %)</th>
                                            <td>
                                                {{ favorite.amount_rent * favorite.agence / 100 * 12 |number:'1.0-1'}}
                                                €/an
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Frais de relocation</th>
                                            <td>
                                                {{favorite.agence_rental}} €/an
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Garantie loyers impayés ({{favorite.amount_rent_insurance}} %)</th>
                                            <td>
                                                {{ favorite.amount_rent * favorite.amount_rent_insurance / 100 * 12 |number:'1.0-1'}}
                                                €/an
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Charges de copropriété</th>
                                            <td>
                                                {{favorite.amount_copro}} €/an
                                            </td>
                                        </tr>
                                        <!--                                <tr>-->
                                        <!--                                    <th>Charges de copropriété locataire</th>-->
                                        <!--                                    <td>-->
                                        <!--                                        {{favorite.amount_copro_rent}} €/an-->
                                        <!--                                    </td>-->
                                        <!--                                </tr>-->
                                        <tr>
                                            <th>Vacance locative ({{ favorite.rental_vacancy }} mois /an)</th>
                                            <td>
                                                {{ favorite.amount_rent * favorite.rental_vacancy |number:'1.0-1'}} €/an
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Autres frais</th>
                                            <td>
                                                {{favorite.other_bill }} €/an
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Comptabilité / CFE</th>
                                            <td>
                                                {{favorite.accouting_fees + favorite.cfe_contribution}}
                                                €/an
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Total</th>
                                            <td>
                                                <b>{{ favorite.charge * 12 | number: '1.0-0' }} €/an</b>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="block_2graph">
                        <div class="card block block_recap">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Achat</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row">
                                    <table>
                                        <tr>
                                            <th>Prix d'achat</th>
                                            <td>{{ favorite.price|number:'1.0-1'}} €</td>
                                        </tr>

                                        <tr>
                                            <th>Surface</th>
                                            <td>{{ favorite.square|number:'1.0-1'}} m²</td>
                                        </tr>
                                        <tr>
                                            <th>Droits de mutation</th>
                                            <td>{{ favorite.notary_price|number:'1.0-1'}} €</td>
                                        </tr>
                                        <tr>
                                            <th>Accompagnement Izimmo</th>
                                            <td>{{ favorite.other_fees|number:'1.0-1'}} €</td>
                                        </tr>
                                        <tr>
                                            <th>Meubles</th>
                                            <td>{{ favorite.furniture_price|number:'1.0-1'}} €</td>
                                        </tr>
                                        <tr>
                                            <th>Travaux</th>
                                            <td>{{ favorite.works_total + favorite.other_fees_work |number:'1.0-1'}} €</td>
                                        </tr>
                                        <tr>
                                            <th>Total achat</th>
                                            <td><b>{{ favorite.total_price|number:'1.0-1'}} €</b></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="card block block_recap">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Crédit </h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row">
                                    <table>
                                        <tr>
                                            <th>Apport</th>
                                            <td>{{ favorite.apport|number:'1.0-1'}} €</td>
                                        </tr>
                                        <tr>
                                            <th>Frais de cautionnement</th>
                                            <td>{{ favorite.deposit_fees|number:'1.0-1'}} €</td>
                                        </tr>
                                        <tr>
                                            <th>Taux crédit</th>
                                            <td>{{ favorite.rate|number:'1.0-1'}} %</td>
                                        </tr>
                                        <tr>
                                            <th>Taux assurance</th>
                                            <td>{{ favorite.rate_insurance|number:'1.0-1'}} %</td>
                                        </tr>
                                        <tr>
                                            <th>Durée</th>
                                            <td>{{ favorite.duration|number:'1.0-1'}} ans</td>
                                        </tr>
                                        <tr>
                                            <th>Annuité</th>
                                            <td>{{ favorite.monthly * 12|number:'1.0-1'}} €</td>
                                        </tr>
                                        <tr>
                                            <th>Mensualité</th>
                                            <td>{{ favorite.monthly|number:'1.0-1'}} €</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="card block block_recap last">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Indicateurs clés </h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row">
                                    <table>
                                        <tr>
                                            <th> Prix au m² à l'achat</th>
                                            <td>{{ favorite.price / favorite.square |number:'1.0-0'}} €/m²</td>
                                        </tr>
                                        <tr>
                                            <th>Prix au m² final</th>
                                            <td>{{ favorite.total_price / favorite.square|number:'1.0-0'}} €/m²</td>
                                        </tr>
                                        <tr>
                                            <th>Rendement brut</th>
                                            <td>{{ favorite.efficiency_brut|number:'1.1-1'}} %</td>
                                        </tr>
                                        <tr>
                                            <th>Rendement net</th>
                                            <td>                    {{ favorite.efficiency_net|number:'1.1-1'}} %
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Cash-flow annuel</th>
                                            <td>
                                                {{ favorite.cash_flow * 12|number:'1.0-0'}} €
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Cash-flow mensuel</th>
                                            <td>
                                                {{ favorite.cash_flow |number:'1.0-0'}} €
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Taux de couverture</th>
                                            <td>{{ favorite.coverage_rate |number:'1.0-1'}} %</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                        Document non contractuel, rédigé à titre indicatif, qui ne saurait
                        engager la responsabilité de {{ pdfConfig.societe}}. L'ensemble des
                        informations diffusées dans ce document sont des estimations
                        susceptibles de varier en fonction des conditions de marché.
                    </span>
                </p>
                <img *ngIf="pdfConfig.visuel_2 != ''" class="bottom_img" src="{{ pdfConfig.visuel_2 }}"/>
            </div>
        </div>

        <div id="patrimoniale" class="page">
            <div class="subpage">
                <div
                    [ngClass]="{'subpageWrap': true, 'withImg': pdfConfig.visuel_3 != '', 'withLegalNotice': pdfConfig.display_legal_notice == true}">
                    <div class="logo_small_wrap {{ pdfConfig.logo_small_style }}">
                        <img class="logo" src="{{ pdfConfig.logo_small_url }}"/>
                    </div>
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse patrimoniale
                        <img *ngIf="pdfConfig.h2_underline_url != ''" class="underline-title"
                             src="{{ pdfConfig.h2_underline_url }}"/>
                    </h2>
                    <div class="kpi-3">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/piggy-bank.png"/>
                            <label>Enrichissement à 10 ans</label>
                            <p class="value">{{ enrichment_10 + favorite.apport | number: '1.0-0' }} €</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <img class="icon" src="assets/009-get-money_white.png"/>
                            <label>Patrimoine acquis par an</label>
                            <p class="value">{{ amort_moy  | number: '1.0-0' }} €</p>
                        </div>
                        <div class="kpi kpi-color-3 kpi-label-2">
                            <img class="icon" src="assets/investment.png"/>
                            <label>Valorisation du<br/>foncier sur 5 ans</label>
                            <p class="value" *ngIf="favorite.ad_city.evol_prix_ville.evol_5y != ''">
                                {{ toFloat(favorite.ad_city.evol_prix_ville.evol_5y) * 100 | number: '1.1-1' }}%
                            </p>
                            <p class="value" *ngIf="favorite.ad_city.evol_prix_ville.evol_5y == ''">-</p>
                        </div>
                    </div>

                    <div class="block_2graph">
                        <div class="card block block_capitalisation">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3 class="{{ pdfConfig.h3_class}} text-color">Évolution du capital net</h3>
                                </div>
                            </div>
                            <div class="card-body col-md-12">
                                <div class="card-text row" *ngIf="capitalData.series.length > 0">
                                    <div echarts [options]="options_Evol_Capital" [merge]="capitalData"
                                         class="capitalChart {{ pdfConfig.visuel_3 == '' ? 'small' : '' }}"
                                         (chartInit)="onChartECInit($event)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>Analyses et dossier effectués en partenariat avec <img width="25"
                                                                                 src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                    <span class="legal_notice" *ngIf="pdfConfig.display_legal_notice">
                        Document non contractuel, rédigé à titre indicatif, qui ne saurait
                        engager la responsabilité de {{ pdfConfig.societe}}. L'ensemble des
                        informations diffusées dans ce document sont des estimations
                        susceptibles de varier en fonction des conditions de marché.
                    </span>
                </p>
                <img *ngIf="pdfConfig.visuel_3 != ''" class="bottom_img" src="{{ pdfConfig.visuel_3 }}"/>
            </div>
        </div>

        <button [hidden]="loading" [disabled]="!ready" (click)="createPdf()"
                class="dl_button btn btn-primary btn-lg text-white">
            <mat-spinner diameter="25" color="second" [hidden]="ready"></mat-spinner>
            <i class="fa cfa cfa-pdf text-white"></i> Télécharger le rapport
        </button>
        <mat-spinner diameter="25" color="second" [hidden]="!loading"></mat-spinner>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="pdfStepContent"
             joyrideStep="pdfStep"
             [stepContentParams]="{'user': authenticationService.currentUser}"
             (prev)="openDropdown()"
             stepPosition="center">
</joyrideStep>

<ng-template #pdfStepContent let-user="user">
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle" /><b>Thomas</b> de LyBox<br/>
    </div>
    <img src="assets/rapport_PDF.png" class="user_onboarding_visuel"/>
    <div class="p-2 user_onboarding_content">
        <h2 *ngIf="user.answer.profil == 'pro'">Impressionnez vos clients avec un rapport PDF à vos
            couleurs</h2>
        <h2 *ngIf="user.answer.profil != 'pro'">Impressionnez votre banquier avec un rapport
            PDF</h2>
        <p>
            Bienvenue dans la génération du rapport PDF de votre analyse.<br/>
            <br/>
            C’est ici que vous allez pouvoir <b>éditer votre rapport puis le télécharger</b>.<br/>
            <br/>
            Je vous montre !<br/>
        </p>
    </div>
</ng-template>

<ng-template #pdfAnnonceStepContent let-user="user">
    <div class="user_onboarding_content">
        <h2>Votre rapport sur mesure</h2>
        <p>
            Le rapport est constitué de plusieurs pages qui présentent les <b>différents aspects de votre projet
            :</b><br/>
        </p>
        <ul>
            <li>Présentation de l’annonce</li>
            <li>Analyse de la ville</li>
            <li>Analyse financière et fiscale</li>
        </ul>
        <p *ngIf="user.answer.profil == 'pro'">
            En tant que professionnel, vous pouvez <b>intégrer votre logo et vos couleurs sur ce rapport.</b>
        </p>
        <p>
            Le texte est modifiable directement en cliquant dessus.<br/>
            <br/>
            Les chiffres sont ceux que vous avez renseignés dans votre simulation.
        </p>
    </div>
</ng-template>

<ng-template #pdfPageStepContent>
    <div class="user_onboarding_content">
        <h2>Sélection des pages</h2>
        <p>
            Avant de télécharger votre rapport, vous pouvez choisir les pages qui vous intéressent.<br/>
            <br/>
            Celles qui ne sont pas cochées n'apparaîtront pas dans votre rapport au moment du téléchargement.
        </p>
    </div>
</ng-template>

<ng-template #pdfDownloadStepContent let-user="user">
    <div class="user_onboarding_content">
        <h2>Télécharger le rapport</h2>
        <p>
            Pour télécharger le rapport en PDF, cliquez ici !<br/>
            <br/>
            La génération du rapport peut prendre plusieurs minutes si vous êtes en haute définition.<br/>
        </p>
        <p *ngIf="user.answer.profil != 'pro'">
            Alors, qui va impressionner son banquier ? 💪
        </p>
        <p *ngIf="user.answer.profil == 'pro'">
            Alors, qui va impressionner ses clients ? 💪
        </p>
    </div>
</ng-template>
